import { render } from "./AccountTypeSearch.vue?vue&type=template&id=5c1d1ba0"
import script from "./AccountTypeSearch.vue?vue&type=script&lang=js"
export * from "./AccountTypeSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__